
export function accessCodeValid (input){
  const re = /[0-9]{11}/g;
  return !re.test(input)
}